<div>
    <p class="mb-5" [innerHTML]="description"></p>

    <p *ngIf="!securityQuestionsForm || !req">
        {{noData}}
    </p>

    <form *ngIf="req && securityQuestionsForm" [formGroup]="securityQuestionsForm">
        <div *ngIf="req">
            <!-- Question 1 -->
            <p class="fs-16 mb-0">{{"label-security-question-1" | translate}}</p>
            <div class="d-flex flex-row mb-3">
                <mat-form-field appearance="outline" class="security-question w-100">
                    <!-- <mat-label>{{"placeholder-question-one" | translate}}</mat-label> -->
                    <mat-select [(ngModel)]="req.Account.Identification_Question1__c"
                        formControlName="Identification_Question1__c" (ngModelChange)="updateQuestion1($event)">
                        <!-- <mat-option [value]="req.Account.Identification_Question1__c">
                            {{req.Account.Identification_Question1__c}}
                        </mat-option> -->
                        <mat-option *ngFor="let q of securityQuestions1" [value]="q">
                            {{q}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- Answer 1 -->
            <div class="d-flex flex-row">
                <mat-form-field appearance="outline" class="security-answer w-100">
                    <input matInput placeholder="{{'security-questions-answer-placeholder' | translate}}" formControlName="Identification_Answer1__c"
                        [ngClass]="{ 'is-invalid': f.Identification_Answer1__c.touched && f.Identification_Answer1__c.errors }"
                        [(ngModel)]="req.Account.Identification_Answer1__c" maxlength="4">
                </mat-form-field>
            </div>
            <div class="d-flex flex-column">
                <small *ngIf="f?.Identification_Answer1__c?.touched && f?.Identification_Answer1__c?.errors" class="text-danger">{{"numeric-security-answer-error" | translate}}</small>
            </div>
            <!-- Question 2  -->
            <p class="mt-5 fs-16 mb-0">{{"label-security-question-2" | translate}}</p>
            <div class="d-flex flex-row mb-3">
                <mat-form-field appearance="outline" class="security-question w-100">
                    <!-- <mat-label>{{"placeholder-question-two" | translate}}</mat-label> -->
                    <mat-select [(ngModel)]="req.Account.Identification_Question2__c"
                        formControlName="Identification_Question2__c" (ngModelChange)="updateQuestion2($event)">
                        <!-- <mat-option [value]="req.Account.Identification_Question2__c">
                            {{req.Account.Identification_Question2__c}}
                        </mat-option> -->
                        <mat-option *ngFor="let q of securityQuestions2" [value]="q">
                            {{q}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- Answer 2 -->
            <div class="d-flex flex-row">
                <mat-form-field appearance="outline" class="security-answer w-100">
                    <input matInput placeholder="{{'security-questions-answer-placeholder' | translate}}" formControlName="Identification_Answer2__c"
                        [ngClass]="{ 'is-invalid': f.Identification_Answer2__c.touched && f.Identification_Answer2__c.errors }"
                        [(ngModel)]="req.Account.Identification_Answer2__c" maxlength="50">
                </mat-form-field>
            </div>
            <div class="d-flex flex-column">
                <!-- <small *ngIf="f?.Identification_Answer2__c?.touched && f?.Identification_Answer2__c?.errors && !patternNumbers.test(req.Account.Identification_Answer2__c) && securityQuestionsForm.get('Identification_Question2__c')?.value === securityQuestions2[0]" class="text-danger">{{"numeric-security-answer-error" | translate}}</small> -->
                <small *ngIf="f?.Identification_Answer2__c?.touched && f?.Identification_Answer2__c?.errors" class="text-danger">{{"security-questions-alphanumerical" | translate}}</small>
            </div>
            <!-- Question 3 -->
            <!--<div class="d-flex flex-row">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Selected security question 03</mat-label>
                                <mat-select [(ngModel)]="req.Account.Identification_Question3__c"
                                    formControlName="Identification_Question3__c">
                                    <mat-option [value]="req.Account.Identification_Question3__c">
                                        {{req.Account.Identification_Question3__c}}
                                    </mat-option>-->
            <!-- <mat-option *ngFor="let q of securityQuestions" [value]="q.id">
                            {{q.viewValue}}
                        </mat-option> -->
            <!--</mat-select>
                            </mat-form-field>
                        </div>-->
            <!-- Answer 3 -->
            <!--<div class="d-flex flex-row">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Answer 03</mat-label>
                                <input matInput placeholder="Answer 03" formControlName="Identification_Answer3__c"
                                    [ngClass]="{ 'is-invalid': f.Identification_Answer3__c.touched && f.Identification_Answer3__c.errors }"
                                    [(ngModel)]="req.Account.Identification_Answer3__c">
                            </mat-form-field>
                        </div>-->
        </div>
    </form>
</div>

<button class="btn btn-primary w-100 mt-5" [disabled]="waitSave || !req || !securityQuestionsForm || !securityQuestionsForm.valid" (click)="saveQuestions()">
    <span>{{"security-questions-action-confirm" | translate}}</span>
    <div *ngIf="waitSave" class="spinner-border ms-2"></div>
</button>